import { render, staticRenderFns } from "./arb-text.vue?vue&type=template&id=328af3ab&"
import script from "./arb-text.vue?vue&type=script&lang=js&"
export * from "./arb-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports